import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
import {
  ManagementScdPresentationImage,
  ExpertPanelReportGuidelinesImage
} from 'assets'

// TODO: Import images from assets

export const ProvidersEducationalResourcesPage: React.FC = () => {
  // TODO: Get content from plans/toolkit_content.json for "Educational Resources" (Providers section)
  // TODO: Convert HTML to JSX
  // TODO: Import and use images

  return (
    <ToolkitPageLayout
      title="Educational Resources"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Providers', path: '/toolkit/providers' },
        {
          label: 'Educational Resources',
          path: '/toolkit/providers/educational-resources'
        }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416]">
        <blockquote className="border-l-4 border-[#A6410A] pl-4 italic my-8">
          <p>
            Our goal for you is to provide pertinent sickle cell disease
            education and resources.
          </p>
        </blockquote>

        <hr className="my-8" />

        <p className="text-xl font-semibold mb-4">
          1. Listen to the presentation on Management of SCD:
        </p>
        <figure className="mb-8 text-center">
          <a
            href="https://hstalks.com/t/3931/management-of-sickle-cell-disease-what-to-do-when-/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-gray-300 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200"
          >
            <img
              src={ManagementScdPresentationImage}
              alt="Presentation on Management of SCD by Sophie Lanzkron"
              className="max-w-full h-auto md:max-w-2xl rounded-lg shadow-md"
            />
          </a>
          <figcaption className="mt-2 text-sm text-gray-600">
            Sophie Lanzkron, MD, MHS, at Johns Hopkins School of Medicine
          </figcaption>
        </figure>

        <p className="text-xl font-semibold mb-4">
          2. Read (and use as reference) the Expert Panel Report, 2014: SCD
          Guidelines:
        </p>
        <figure className="mb-8 text-center">
          <a
            href="https://www.nhlbi.nih.gov/sites/default/files/media/docs/Evd-Bsd_SickleCellDis_Rep2014.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-gray-300 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200"
          >
            <img
              src={ExpertPanelReportGuidelinesImage}
              alt="Expert Panel Report 2014: SCD Guidelines"
              className="max-w-full h-auto md:max-w-2xl rounded-lg shadow-md"
            />
          </a>
          <figcaption className="mt-2 text-sm text-gray-600">
            U.S. Department of Health and Human Services, National Institutes of
            Health
          </figcaption>
        </figure>

        <hr className="my-12" />

        <div className="mt-12 mb-8 text-center">
          <Link
            to="/toolkit/providers"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Providers screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
